import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const QuestionOutlined: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[20px] h-[20px]', className)}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.62383 3.62384C5.30385 1.94382 7.58244 1 9.95833 1C12.3342 1 14.6128 1.94382 16.2928 3.62384C17.9728 5.30385 18.9167 7.58244 18.9167 9.95833C18.9167 11.1348 18.685 12.2997 18.2348 13.3865C17.7846 14.4734 17.1247 15.461 16.2928 16.2928C15.461 17.1247 14.4734 17.7846 13.3865 18.2348C12.2997 18.685 11.1348 18.9167 9.95833 18.9167C8.78191 18.9167 7.617 18.685 6.53013 18.2348C5.44325 17.7846 4.45569 17.1247 3.62383 16.2928C2.79198 15.461 2.13211 14.4734 1.68191 13.3865C1.23171 12.2997 1 11.1348 1 9.95833C1 7.58244 1.94382 5.30385 3.62383 3.62384ZM9.95833 2.46259C7.97034 2.46259 6.06376 3.25231 4.65804 4.65804C3.25231 6.06377 2.46259 7.97034 2.46259 9.95833C2.46259 10.9427 2.65647 11.9174 3.03316 12.8268C3.40986 13.7363 3.96199 14.5626 4.65804 15.2586C5.35408 15.9547 6.18041 16.5068 7.08983 16.8835C7.99926 17.2602 8.97398 17.4541 9.95833 17.4541C10.9427 17.4541 11.9174 17.2602 12.8268 16.8835C13.7363 16.5068 14.5626 15.9547 15.2586 15.2586C15.9547 14.5626 16.5068 13.7363 16.8835 12.8268C17.2602 11.9174 17.4541 10.9427 17.4541 9.95833C17.4541 7.97034 16.6644 6.06377 15.2586 4.65804C13.8529 3.25231 11.9463 2.46259 9.95833 2.46259Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.99967 12.667C10.3679 12.667 10.6663 12.9655 10.6663 13.3337V13.342C10.6663 13.7102 10.3679 14.0087 9.99967 14.0087C9.63148 14.0087 9.33301 13.7102 9.33301 13.342V13.3337C9.33301 12.9655 9.63148 12.667 9.99967 12.667Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.55457 6.87901C10.0672 6.77645 10.5993 6.85027 11.0647 7.08845C11.5319 7.32669 11.9052 7.7154 12.1244 8.19186C12.3438 8.66853 12.396 9.20522 12.2727 9.71525C12.1495 10.2253 11.8579 10.6789 11.4451 11.0028C11.0323 11.3267 10.5224 11.502 9.99769 11.5005C9.6295 11.4993 9.33192 11.2 9.33303 10.8318C9.33413 10.4636 9.6335 10.166 10.0017 10.1671C10.2266 10.1678 10.4451 10.0927 10.622 9.95384C10.7989 9.81502 10.9239 9.62062 10.9767 9.40204C11.0295 9.18345 11.0071 8.95345 10.9132 8.74915C10.8192 8.54486 10.6591 8.37822 10.4587 8.27612L10.4574 8.27547C10.2598 8.17426 10.0338 8.14288 9.81616 8.18643C9.59849 8.22998 9.40196 8.34591 9.25854 8.51534C9.02065 8.79637 8.6 8.83135 8.31897 8.59347C8.03794 8.35559 8.00296 7.93493 8.24084 7.6539C8.57873 7.25472 9.04175 6.98162 9.55457 6.87901Z"
      fill="currentColor"
    />
  </svg>
);

export default QuestionOutlined;
